"use strict";

exports.__esModule = true;
exports.DeviceConnectivityFields = DeviceConnectivityFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// TODO: translation

function DeviceConnectivityFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
      "data-testid": "DeviceConnectivityFields.showAgentStatus",
      checked: element.props.showAgentStatus,
      label: translate("DeviceConnectivityFields.showAgentStatus.label", "Show Agent Status"),
      onChange: function onChange() {
        return elementEditor.setProp(path, "showAgentStatus", !element.props.showAgentStatus);
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
      "data-testid": "DeviceConnectivityFields.showAdapterStatus",
      checked: element.props.showAdapterStatus,
      label: translate("DeviceConnectivityFields.showAdapterStatus.label", "Show Adapter Status"),
      onChange: function onChange() {
        return elementEditor.setProp(path, "showAdapterStatus", !element.props.showAdapterStatus);
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
      "data-testid": "DeviceConnectivityFields.showDataSourceStatus",
      checked: element.props.showDataSourceStatus,
      label: translate("DeviceConnectivityFields.showDataSourceStatus.label", "Show Data Source status"),
      onChange: function onChange() {
        return elementEditor.setProp(path, "showDataSourceStatus", !element.props.showDataSourceStatus);
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DeviceConnectivityFields.entityRelativeWidth.label", "Entity Column Relative Width"),
      helperText: translate("DeviceConnectivityFields.entityRelativeWidth.helperText", "The width of entity column relative to others")
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      "data-testid": "DeviceConnectivityFields.entityRelativeWidth",
      labelRenderer: false,
      min: 0,
      max: 100,
      value: element.props.entityRelativeWidth || 25,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "entityRelativeWidth", value);
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DeviceConnectivityFields.hostRelativeWidth.label", "Host Column Relative Width"),
      helperText: translate("DeviceConnectivityFields.hostRelativeWidth.helperText", "The width of host column relative to others")
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      "data-testid": "DeviceConnectivityFields.hostRelativeWidth",
      labelRenderer: false,
      min: 0,
      max: 100,
      value: element.props.hostRelativeWidth || 25,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "hostRelativeWidth", value);
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DeviceConnectivityFields.portRelativeWidth.label", "Port Column Relative Width"),
      helperText: translate("DeviceConnectivityFields.portRelativeWidth.helperText", "The width of port column relative to others")
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      "data-testid": "DeviceConnectivityFields.portRelativeWidth",
      labelRenderer: false,
      min: 0,
      max: 100,
      value: element.props.portRelativeWidth || 25,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "portRelativeWidth", value);
      }
    })));
  });
}